import { useBindApplication } from "@Client/@Composables/application-standalone/useBindApplication";
export const useMortgageDetailsFieldBindings = () => {
  const rootPath = "[mortgage-details]";
  const {
    bindApplication
  } = useBindApplication();
  const mortgageDetails = bindApplication(rootPath);
  const mortgageDetailsClosingDate = bindApplication(rootPath + "[mortgage-details][closing-date]", "");
  return {
    mortgageDetails,
    mortgageDetailsClosingDate
  };
};